import { render } from "./AppViewComponent.vue?vue&type=template&id=1d084266"
import script from "./AppViewComponent.vue?vue&type=script&lang=js"
export * from "./AppViewComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__